import React, { useState, useEffect, useContext } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import * as Sentry from "@sentry/react";
import {
  Grid,
  Box,
  Button,
  TextField,
  Typography,
  Hidden,
  Checkbox,
} from "@material-ui/core";
import { BsExclamationCircle } from "react-icons/bs";
import { CoinContext } from "../../contexts/CoinContext";
import { REACT_APP_PROD_URL } from "../../services/configs";
import { useSelector } from "react-redux";
import fetcher from "../../api/swr_fetcher";

export default function Settings() {
  const classes = useStyles();
  // const theme = useTheme();
  let history = useHistory();

  const token = useSelector((state) => state.trading.TOKEN);

  const [nomineeName, setNomineeName] = useState(null);
  const [nomineeNum, setNomineeNum] = useState(null);
  const [nomineeRelationship, setNomineeRelationship] = useState(null);
  const [existingNominee, setExistingNominee] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const [checked, setChecked] = useState(false);

  const [errorFields, setErrorFields] = useState({
    name: false,
    num: false,
    relation: false,
  });

  const { handleClickAlert } = useContext(CoinContext);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  useEffect(() => {
    if (token) {
      // console.log("what?");
      fetcher(`/v1/um/nominee`)
        .then((data) => {
          if (!data.status) {
            setExistingNominee(data);
          }
          // console.log(data);
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });
    }
  }, [refresh]);

  function addNominee() {
    if (token && nomineeName && nomineeNum && nomineeRelationship) {
      fetcher(`/v1/um/addNominee/`, {
        method: "POST",
        body: {
          name: nomineeName,
          phonenumber: nomineeNum,
          relationship: nomineeRelationship,
          notifyNominee: true,
        },
      })
        .then((res) => {
          handleClickAlert("success", "Successfully added nominee");
          setRefresh(!refresh);

          // console.log(res);
        })
        .catch((err) => {
          handleClickAlert("error", "Request failed");
          console.error(err);
          // console.error(err);
        });
    } else {
      setErrorFields({
        name: nomineeName ? false : true,
        num: nomineeNum ? false : true,
        relation: nomineeRelationship ? false : true,
      });
    }
  }

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        // console.log("Yo you pressed enter");
        addNominee();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  return (
    <div className={classes.root}>
      {/* <Hidden smDown> */}
      <p className={classes.topHeading}>Nominee</p>

      <Grid container className={classes.paddedContainer}>
        <Grid item xs={12}>
          {/*Nominee*/}

          {existingNominee ? (
            <div style={{ marginBottom: "20px" }}>
              <Hidden smDown>
                <Box>
                  <Typography
                    variant="h4"
                    component="h4"
                    className={classes.stepHeading}
                  >
                    Nominee Details
                  </Typography>
                </Box>
              </Hidden>

              <div className={classes.notice}>
                <div className={classes.flexContainer}>
                  <BsExclamationCircle
                    style={{ fontSize: "20px", color: "#3AC4AB" }}
                  />
                  <p
                    style={{
                      color: "#3AC4AB",
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginLeft: "15px",
                    }}
                  >
                    Important
                  </p>
                </div>
                <div style={{ marginLeft: "35px", marginTop: "5px" }}>
                  The Nominee feature lets you to add a beneficiary to your
                  PocketBits account. This allows them to claim your Crypto
                  assets in case of any unforeseen circumstances.
                </div>
              </div>

              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="body1"
                  component="p"
                  className={classes.fieldLabel}
                >
                  Name
                </Typography>
              </Box>
              <Box>
                <TextField
                  fullWidth={true}
                  name="nomineename"
                  required
                  className={classes.textFieldRoot}
                  InputProps={{
                    classes: { root: classes.textFieldStyles },
                  }}
                  variant="outlined"
                  value={existingNominee.name}
                  style={{ pointerEvents: "none", opacity: "0.4" }}
                />
              </Box>
              <Box>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="body1"
                        component="p"
                        className={classes.fieldLabel}
                      >
                        PHONE NUMBER
                      </Typography>
                    </Box>
                    <Box>
                      <TextField
                        fullWidth={true}
                        name="num"
                        required
                        className={classes.textFieldRoot}
                        InputProps={{
                          classes: { root: classes.textFieldStyles },
                          inputProps: { maxLength: 10 },
                        }}
                        variant="outlined"
                        value={existingNominee.phonenumber}
                        style={{ pointerEvents: "none", opacity: "0.4" }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="body1"
                        component="p"
                        className={classes.fieldLabel}
                      >
                        RELATIONSHIP
                      </Typography>
                    </Box>
                    <Box>
                      <TextField
                        fullWidth={true}
                        name="relation"
                        required
                        className={classes.textFieldRoot}
                        InputProps={{
                          classes: { root: classes.textFieldStyles },
                        }}
                        variant="outlined"
                        value={existingNominee.relationship}
                        style={{ pointerEvents: "none", opacity: "0.4" }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </div>
          ) : (
            <div style={{ marginBottom: "20px" }}>
              <Box>
                <Typography
                  variant="h4"
                  component="h4"
                  className={classes.stepHeading}
                >
                  Add Nominee Details
                </Typography>
                <Typography
                  variant="body1"
                  component="p"
                  gutterBottom
                  className={classes.stepSubHeading}
                >
                  Enter nominee details below
                </Typography>
              </Box>

              <div className={classes.notice}>
                <div className={classes.flexContainer}>
                  <BsExclamationCircle
                    style={{ fontSize: "20px", color: "#3AC4AB" }}
                  />
                  <p
                    style={{
                      color: "#3AC4AB",
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginLeft: "15px",
                    }}
                  >
                    Important
                  </p>
                </div>
                <div style={{ marginLeft: "35px", marginTop: "5px" }}>
                  The Nominee feature lets you to add a beneficiary to your
                  PocketBits account. This allows them to claim your Crypto
                  assets in case of any unforeseen circumstances.
                </div>
              </div>

              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="body1"
                  component="p"
                  className={classes.fieldLabel}
                >
                  Name
                </Typography>
              </Box>
              <Box>
                <TextField
                  fullWidth={true}
                  name="nomineename"
                  required
                  className={classes.textFieldRoot}
                  InputProps={{
                    classes: { root: classes.textFieldStyles },
                  }}
                  variant="outlined"
                  value={nomineeName}
                  onChange={(e) => {
                    let val = e.target.value.replace(/[^a-zA-Z\s]/, "");
                    setNomineeName(val);
                  }}
                  error={errorFields.name}
                  helperText={errorFields.name ? "Please enter name" : null}
                />
              </Box>
              <Box>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="body1"
                        component="p"
                        className={classes.fieldLabel}
                      >
                        PHONE NUMBER
                      </Typography>
                    </Box>
                    <Box>
                      <TextField
                        fullWidth={true}
                        name="num"
                        required
                        className={classes.textFieldRoot}
                        InputProps={{
                          classes: { root: classes.textFieldStyles },
                          inputProps: { maxLength: 10 },
                        }}
                        variant="outlined"
                        value={nomineeNum}
                        onChange={(e) => {
                          let val = e.target.value.replace(/[^0-9]/, "");
                          setNomineeNum(val);
                        }}
                        error={errorFields.num}
                        helperText={
                          errorFields.num ? "Please enter number" : null
                        }
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="body1"
                        component="p"
                        className={classes.fieldLabel}
                      >
                        RELATIONSHIP
                      </Typography>
                    </Box>
                    <Box>
                      <TextField
                        fullWidth={true}
                        name="relation"
                        required
                        className={classes.textFieldRoot}
                        InputProps={{
                          classes: { root: classes.textFieldStyles },
                        }}
                        variant="outlined"
                        value={nomineeRelationship}
                        onChange={(e) => {
                          let val = e.target.value.replace(/[^a-zA-Z\s]/, "");
                          setNomineeRelationship(val);
                        }}
                        error={errorFields.relation}
                        helperText={
                          errorFields.relation
                            ? "Please enter relationship"
                            : null
                        }
                      />
                    </Box>
                  </Grid>
                </Grid>

                <div style={{ display: "flex", margin: "30px 0px" }}>
                  <Checkbox
                    checked={checked}
                    onChange={handleChange}
                    color="primary"
                    inputProps={{ "aria-label": "primary checkbox" }}
                    style={{
                      padding: 0,
                      margin: 0,
                      marginRight: "10px",
                      height: "26px",
                    }}
                  />
                  <p>
                    I consent to my nominee receiving a text message notifying
                    them about being added as the beneficiary to my PocketBits
                    account.
                  </p>
                </div>
                <div>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={addNominee}
                    disabled={!checked}
                  >
                    Submit
                  </Button>
                </div>
              </Box>
            </div>
          )}
        </Grid>
      </Grid>
      {/* </Hidden> */}

      {/* <Hidden mdUp>
        <div style={{ marginBottom: "40px" }}>
          <Box>
            <Typography
              variant="h4"
              component="h4"
              className={classes.stepHeading}
            >
              Add Nominee Details
            </Typography>
            <Typography
              variant="body1"
              component="p"
              gutterBottom
              className={classes.stepSubHeading}
            >
              Enter nominee details below
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Typography
              variant="body1"
              component="p"
              className={classes.fieldLabel}
            >
              Name
            </Typography>
          </Box>
          <Box mt={1}>
            <TextField
              fullWidth={true}
              name="nomineename"
              required
              className={classes.textFieldRoot}
              InputProps={{
                classes: { root: classes.textFieldStyles },
              }}
              variant="outlined"
              onChange={(e) => setNomineeName(e.target.value)}
            />
          </Box>
          <Box mt={1}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Box display="flex" justifyContent="space-between">
                  <Typography
                    variant="body1"
                    component="p"
                    className={classes.fieldLabel}
                  >
                    PHONE NUMBER
                  </Typography>
                </Box>
                <Box mt={1}>
                  <TextField
                    fullWidth={true}
                    name="state"
                    required
                    className={classes.textFieldRoot}
                    InputProps={{
                      classes: { root: classes.textFieldStyles },
                    }}
                    variant="outlined"
                    type="number"
                    onChange={(e) => setNomineeNum(e.target.value)}
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box display="flex" justifyContent="space-between">
                  <Typography
                    variant="body1"
                    component="p"
                    className={classes.fieldLabel}
                  >
                    RELATIONSHIP
                  </Typography>
                </Box>
                <Box mt={1}>
                  <TextField
                    fullWidth={true}
                    name="zip"
                    required
                    className={classes.textFieldRoot}
                    InputProps={{
                      classes: { root: classes.textFieldStyles },
                    }}
                    variant="outlined"
                    onChange={(e) => setNomineeRelationship(e.target.value)}
                  />
                </Box>
              </Grid>
            </Grid>

            <div style={{ textAlign: "right" }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={addNominee}
              >
                Submit
              </Button>
            </div>
          </Box>
        </div>
      </Hidden>
     */}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    // marginTop: theme.spacing(10),
    // marginLeft: theme.spacing(10),
    // alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      // width: '90%',
      marginTop: "70px",
      // maxWidth: "450px",
      // minWidth: "450px",
      width: "100%",
      // marginLeft: "25px",
      marginRight: "25px",
    },
    [theme.breakpoints.up("md")]: {
      // width: "50%",
      marginTop: "50px",
    },
    // margin: "auto",
    marginBottom: "80px",
  },
  paddedContainer: {
    [theme.breakpoints.up("md")]: {
      padding: "40px",
    },
    background: theme.palette.type === "dark" ? "#151827" : "white",
  },
  topHeading: {
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.3rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "2rem",
      color: "#3AC4AB",
    },
  },
  twoFactorContainer: {
    border: `1px solid #3AC4AB`,
    backgroundColor: "rgba(86,195,164,0.1)",
    padding: "6px 12px",
    borderRadius: "2px",
  },
  labelText: {
    fontWeight: "bold",
    color: theme.palette.text.primary,
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.8rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem",
    },
  },
  stepHeading: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.3rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.5625rem",
    },
  },
  stepSubHeading: {
    color: theme.palette.text.primary,
    opacity: 0.6,
    letterSpacing: 0.3,
  },
  textFieldRoot: {
    "& > p": {
      color: theme.palette.text.primary,
      opacity: 0.5,
      fontSize: "13px",
      lineHeight: "16px",
    },
  },
  textFieldStyles: {
    border: `1px solid ${theme.palette.text.primary}40`,
    borderRadius: 3,
    "&::before": {
      display: "none",
    },
    "& input": {
      padding: "12px 14px",
      color: theme.palette.text.primary,
      fontWeight: "bold",
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
    },
  },
  fieldLabel: {
    fontWeight: "bold",
    color: theme.palette.text.primary,
    opacity: "0.5",
    textTransform: "uppercase",
    marginTop: "17px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.8rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem",
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    color: "#fff",
    fontWeight: "600",
    width: "150px",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
  },
  notice: {
    border: `1px solid #3AC4AB`,
    backgroundColor: "rgba(86,195,164,0.1)",
    padding: "15px",
    // marginTop: "20px",
    // marginLeft: "15px",
    // marginRight: "15px",
    borderRadius: "8px",
    marginTop: "20px",
    marginBottom: "15px",
  },
}));
